export class RegistrationRequest {
	agencyID: string;
	licensePlate?: string;
	pin?: string;
	dateOfBirth?: string;
	expirationDate?: string;
	pageSize?: number;
	targetPageNumber?: number;
	qrCode?: boolean;
	token?: string;
}
